var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('v-btn',{attrs:{"icon":"icon","fab":"fab"},on:{"click":() => _vm.$router.go(-1)}},[_c('v-icon',[_vm._v("mdi-arrow-left")])],1),_c('h1',[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }